/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const getShellThemeMode = (): string => {
  return window?.Shell?.v1?.theme?.getUserThemeMode?.() || 'light';
};

export const getShellDirection = (React: any): any => {
  return window?.Shell?.v1?.localization?.useReactGetLanguageDirection?.(React);
};

export const getShellAppContext = (): string => {
  return (window?.Shell?.v1?.app as any)?.getApplicationContext?.();
};

export const useShellAuthenticationData = (React: any): any => {
  return (window?.Shell?.v1?.userInterface as any)?.useAuthenticationData?.(
    React
  );
};
